const UTM_INPUT_TYPE = "utm";
const URL_PARAMETER_INPUT_TYPE = "urlparameter";
const URL_PARAMETER_NAME_PREFIX = "clk_";

function isAlwaysHiddenInputType(inputType: string) {
  return inputType === UTM_INPUT_TYPE;
}

function normalizeUrlParameterName(name: string) {
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_-]/g, "");
}

export function isValidUrlParameterName(name: string) {
  return /^clk_[A-Za-z0-9_-]+$/.test(name);
}

export function getDefaultUrlParameterName(name: string) {
  const normalizedName = normalizeUrlParameterName(name || "");
  const nameWithoutPrefix = normalizedName.startsWith(URL_PARAMETER_NAME_PREFIX)
    ? normalizedName.slice(URL_PARAMETER_NAME_PREFIX.length)
    : normalizedName.replace(/^clk_?/, "");
  const safeName = nameWithoutPrefix || "parameter";

  return `${URL_PARAMETER_NAME_PREFIX}${safeName}`;
}

function SingleInputPropertiesHelper(question: any) {
  if (question.inputType === "money") {
    question.inputMask = "currency";
    question.crmFieldType = "money";
  }
  if (question.inputType === "decimal") {
    question.inputMask = "decimal";
    question.crmFieldType = "decimal";
  }
  if (question.inputType === "email") {
    question.inputMask = "email";
    question.crmFieldType = "email";
  }
  if (question.inputType === "integer") {
    question.inputMask = "integer";
    question.crmFieldType = "integer";
  }
  if (question.inputType === "text") {
    question.inputMask = "none";
    question.crmFieldType = "text";
  }
  if (question.inputType === "url") {
    question.inputMask = "url";
    question.crmFieldType = "url";
  }
  if (question.inputType === "utm") {
    question.inputMask = "none";
    question.crmFieldType = "utm";
  }

  if (question.inputType === URL_PARAMETER_INPUT_TYPE) {
    question.inputMask = "none";
    question.crmFieldType = "text";
  }

  if (question.inputType !== UTM_INPUT_TYPE) {
    question.utmMap = null;
  }

  if (question.inputType === URL_PARAMETER_INPUT_TYPE) {
    question.clearPropertyValue("contactMap");
    question.clearPropertyValue("leadMap");
    question.clearPropertyValue("crmMaxLength");
    question.clearPropertyValue("crmContactMaxLength");
    question.clearPropertyValue("crmLeadMaxLength");
    return;
  }

  if (!isAlwaysHiddenInputType(question.inputType)) {
    question.setPropertyValue("visible", true);
  } else {
    question.visible = false;
    question.setPropertyValue("visible", false);
    question.clearPropertyValue("contactMap");
    question.clearPropertyValue("leadMap");
    question.clearPropertyValue("crmMaxLength");
    question.clearPropertyValue("crmContactMaxLength");
    question.clearPropertyValue("crmLeadMaxLength");
  }
}

export default SingleInputPropertiesHelper;
